import {
    get,
    put,
    post,
    Delete,
    formDataPost,
    axios
} from "../ApiDecorator"; // 倒入 api

const Paired = {
    // 获取全部结对空间
    getListByProject(data) {
        return get("/course/spx/listByProject", data);
    },
    // 获取我的结对空间
    getListByOwner(data) {
        return get("/course/spx/listByOwner", data);
    },
    // 空间管理-课表列表（spaceIds 数组：spaceIds=1&spaceIds=2）
    getCourseList(data) {
        return get("/learn/spx/schedule/scheduleRowsBySpaceIds", data);
    },
    // 空间管理-导出 Word 压缩包（blob）
    exportCourseList(data) {
        const params = { ...data, noCache: new Date().getTime() }
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&')
        return axios.get(`/learn/spx/schedule/exportScheduleWordZip?${query}`, {
            responseType: 'blob',
        }).then(res => res.data)
    },
}

export default Paired